<template>
    <el-container>
        <el-header style="padding: 0; min-height: 30px;">
            <el-page-header @back="goBack" content="首页名师推荐">
            </el-page-header>
        </el-header>
        <el-main>
            <el-button type="success" icon="el-icon-circle-plus-outline" size="small" round @click="showTeacher" class="but-cls">添加推荐教师</el-button>
            <el-dialog :visible.sync="addTeacher" :close-on-click-modal=false width="60%" :before-close="handleDialogClose" top="10vh">
                <el-form ref="searchDate" :model="searchData" label-width="80px" label-position="top">
                    <el-row >
                        <el-col :span="6" class="cls-col">
                            <el-form-item label="教师姓名" prop="teacherName" style="width: 70%">
                                <el-input v-model="searchData.teacherName" placeholder="教师姓名" size="small" ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="机构" prop="orgCode">
                                <el-select v-model="searchData.orgCode" clearable placeholder="机构" size="small" style="width: 70%">
                                    <el-option v-for="o in org" :label="o.organizationName" :value="o.orgCode" ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item >
                        <el-button type="primary" plain size="small" icon="el-icon-search" @click="search()">查询</el-button>
                        <el-button type="success"  size="small" icon="el-icon-search" @click="saveRecommendTeacher()">提交</el-button>
                    </el-form-item>

                </el-form>
                <el-table
                        :data="staffData"
                        border
                        ref = "multipleTable"
                        highlight-current-row
                        v-loading="loading"
                        style="width: 100%; margin-bottom: 20px;"
                        @selection-change="handleSelectionChange"
                >
                    <el-table-column
                            type="selection"
                            width="55"
                    >
                    </el-table-column>
                    <el-table-column
                            type="index"
                            label="序号"
                            width="50"
                            fixed="left"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="teacherName"
                            label="教师姓名"
                            width="200"
                            fixed="left"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="teacherZili"
                            label="教师资历"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="organizationName"
                            label="机构"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="status"
                            label="状态"
                            :formatter="teacherStatus"
                            width="80"
                    >
                    </el-table-column>
                </el-table>
                <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="total"
                        :page-size="pageSize"
                        :current-page.sync="currentPage"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        style="margin-top: -5px; float: right; margin-right: 10px">
                </el-pagination>
            </el-dialog>
            <el-table
                    :data="recommendTeacherData"
                    border
                    ref = "multipleTable"
                    highlight-current-row
                    v-loading="loading"
                    style="width: 100%; margin-bottom: 20px;"
            >
                <el-table-column
                        type="index"
                        label="序号"
                        width="50"
                        fixed="left"
                >
                </el-table-column>
                <el-table-column
                        prop="teacherName"
                        label="教师姓名"
                        width="200"
                        fixed="left"
                >
                </el-table-column>
                <el-table-column
                        prop="teacherZili"
                        label="教师资历"
                >
                </el-table-column>
                <el-table-column
                        prop="organizationName"
                        label="机构"
                >
                </el-table-column>
                <el-table-column
                        prop="status"
                        label="状态"
                        :formatter="teacherStatus"
                        width="80"
                >
                </el-table-column>
                <el-table-column
                        prop="sort"
                        label="排序"
                        width="80"
                        align="center"
                >
                    <template slot-scope="{row,$index}">
                        <input class="edit-cell" v-if="showEdit[row.teacherId]" v-model="row.typeSort" >
                        <span v-if="!showEdit[row.teacherId]">{{row.typeSort}}</span>
                    </template>
                </el-table-column>

                <el-table-column
                        fixed="right"
                        label="操作"
                        width="250"
                >
                    <template slot-scope="scope">
                        <el-button @click="handleEdit(scope.$index, scope.row)" v-if="!showEdit[scope.row.teacherId]"  type="text" size="small" >排序</el-button>
                        <el-button @click="changeSort(scope.row)" v-if="showEdit[scope.row.teacherId]"  type="text" size="small" >更新</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-main>
    </el-container>
</template>

<script>
    import https from '@/https.js'
    import {validateSort} from '@/api/validate.js'

    const form = {
        teacherId: "",
        teacherName: "",
        teacherZili: "",
        teachCourse: "",
        orgCode: "",
        teacherJianjie: "",
        teacherHeader: "",
        status: 1,
    };
    export default {
        data() {
            return {
                loading: true,
                form: JSON.parse(JSON.stringify(form)),
                searchData: {
                    orgCode: "",
                    ccId: "",
                    page: 1,
                    size: 10,
                    status: "",
                    teacherId: "",
                    teacherName: "",
                    type: "",
                },
                multipleSelection: [],
                rules: {
                    teacherName: [
                        { required: true, message: '请输入姓名', trigger: 'blur' },
                        { max:50, message: '长度不得超过50个字符', trigger: 'blur' }
                    ],
                    teacherZili: [
                        {required: true, message: '请输入资历', trigger: 'blur' },
                        { max:50, message: '长度不得超过50个字符', trigger: 'blur' }
                    ],
                    teachCourse: [
                        {required: true, message: '请输入讲授课程', trigger: 'blur' },
                        { max:50, message: '长度不得超过50个字符', trigger: 'blur' }
                    ],
                    teacherJianjie: [
                        {required: true, message: '请输入简介', trigger: 'blur' },
                        { max:2000, message: '长度不得超过2000个字符', trigger: 'blur' }
                    ],
                    orgCode: [
                        {required: true, message: '请选择机构', trigger: 'blur' }
                    ]
                },
                total: 0,
                pageSize:10,
                addTeacher: false,
                staffData: [],
                recommendTeacherData: [],
                dialogImageUrl: '',
                dialogVisible: false,
                uploadURL: "",
              myHeaders: {
                Authentication: localStorage.getItem("token")
              },
                title: "新增教师",
                fileList: [],
                hideUpload: false,
                limitCount:1,
                currentPage: 1,
                prePage: 1,
                recommendTeacher:[],
                showEdit: [],
                currentPageTeacher: [],
                org: [],
            }
        },
        watch:{
            staffData:function(){
                this.$nextTick(function(){
                    this.staffData.forEach(row => {
                        if(this.recommendTeacher.indexOf(row.teacherId) > -1){
                            this.$refs.multipleTable.toggleRowSelection(row);
                        }
                    });
                });
            }
        },
        methods: {
            showTeacher() {
                this.addTeacher = true;
                this.search();
                let params = {
                    orgCode: ""
                };
                https.fetchPost('/managerTeacher/selectRecommendTeacherId',params , "json").then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;

                    if(code == '200') {
                        if(data.data.data != null) {
                            this.recommendTeacher = data.data.data;
                        }
                    }
                }).catch(err=>{
                        this.$message.error('网络异常！');
                    }
                )
            },
            saveRecommendTeacher() {
                this.changeRecommendTeacher();
                let params = {
                    teacherIdList: this.recommendTeacher
                };
                https.fetchPost('/managerTeacher/updateRecommendTeacher',params , "json").then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;

                    if(code == '200') {
                        this.$message({
                            type: 'success',
                            message: '操作成功!'
                        });
                        this.addTeacher = false;
                        this.searchRecommendTeacher();
                    } else {
                        this.$message({
                            type: 'info',
                            message: '操作失败:'+msg
                        });
                    }
                }).catch(err=>{
                        this.$message.error('网络异常！');
                    }
                )

            },
            searchRecommendTeacher() {
                let params = {
                    orgCode: "",
                    page: "1",
                    size: "999",
                    type: 2
                };
                https.fetchPost('/managerTeacher/searchTeacher',JSON.parse(JSON.stringify(params)),"json" ).then((data) => {
                    let code = data.data.code;
                    if(code == '200') {
                        this.recommendTeacherData = data.data.data.list;
                        this.loading = false;
                    }
                }).catch(err=>{
                        console.log(err)
                        this.loading = false;
                        this.$message.error('数据加载失败');
                    }
                )
            },
            changeSort(val) {
                const reg = /^\d{1,3}$/;
                if(!reg.test(val.typeSort)) {
                    this.$message.error('最多输入3位数字');
                    return;
                }
                this.updateSort(val)
            },
            handleEdit(index, row) {
                this.showEdit[row.teacherId] = true;
                this.searchRecommendTeacher();
            },
            handleRemove(file, fileList) {
                this.hideUpload = fileList.length >= this.limitCount;
            },
            onChange(file, fileList) {
                this.hideUpload = fileList.length >= this.limitCount;
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleSuccess(response, file, fileList) {
                this.form.teacherHeader = response.data;
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type === 'image/jpeg'|| file.type === 'image/png';
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPG) {
                    this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 2MB!');
                }
                return isJPG && isLt2M;
            },
            handleDialogClose() {
                this.addTeacher = false;
                this.title = "新增教师";
                this.fileList = [];
                this.form = JSON.parse(JSON.stringify(form));
            },
            detail(index, row) {
                this.$router.push({
                    name: "teacherDetail",
                    params: row,
                });
            },
            handleSelectionChange(val) {
                this.multipleSelection = [];
                for(let index in val) {
                    this.multipleSelection[index] =  val[index].teacherId;
                }
            },
            deleteMore() {
                let roleLength = this.multipleSelection.length;
                this.$confirm('此操作将删除'+roleLength+'条用户信息, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let multipleSelection = this.multipleSelection;
                    let params = multipleSelection;
                    https.fetchPost('/managerTeacher/deleteByTeacherIdList',params , "json").then((data) => {
                        let code = data.data.code;
                        let msg = data.data.msg;
                        if(code == '200') {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.search();
                        } else {
                            this.$message({
                                type: 'info',
                                message: '删除失败:'+msg
                            });
                        }
                    }).catch(err=>{
                            this.$message.error('网络异常！');
                        }
                    )

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            deleteTeacher(index, row) {
                this.$confirm('此操作将删除该推荐教师, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params ={
                      orgCode: "",
                      teacherIdList:   [row.teacherId]
                    };
                    https.fetchPost('/managerTeacher/deleteRecommendTeacher',params , "json").then((data) => {
                        let code = data.data.code;
                        let msg = data.data.msg;
                        if(code == '200') {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.searchRecommendTeacher();
                        } else {
                            this.$message({
                                type: 'info',
                                message: '删除失败:'+msg
                            });
                        }
                    }).catch(err=>{
                            this.$message.error('网络异常！');
                        }
                    )

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            search(val) {
                if(val) {
                    this.searchData.page = val;
                } else {
                    this.searchData.page = 1;
                    this.currentPage = 1;
                }
                this.searchData.size = this.pageSize;
                this.searchData.status = 1;
                let params = this.searchData;
                this.loading = true;
                https.fetchPost('/managerTeacher/searchTeacher',JSON.parse(JSON.stringify(params)),"json" ).then((data) => {
                    let code = data.data.code;
                    if(code == '200') {
                        this.currentPageTeacher = [];
                        this.staffData = data.data.data.list;
                        for(let index in this.staffData) {
                            this.currentPageTeacher.push(this.staffData[index].teacherId);
                        }
                        this.total = data.data.data.total;
                        this.loading = false;
                    }
                }).catch(err=>{
                        console.log(err)
                        this.loading = false;
                        this.$message.error('数据加载失败');
                    }
                )

            },
            handleSizeChange() {},
            changeRecommendTeacher() {
                for(let index in this.currentPageTeacher) {
                    if(this.multipleSelection.indexOf(this.currentPageTeacher[index]) > -1) {
                        if(!(this.recommendTeacher.indexOf(this.currentPageTeacher[index]) > -1)) {
                            this.recommendTeacher.push(this.currentPageTeacher[index]);
                        }
                    } else {
                        let i = this.recommendTeacher.indexOf(this.currentPageTeacher[index])
                        if(i > -1) {
                            this.recommendTeacher.splice(i, 1);
                        }
                    }
                }
            },
            handleCurrentChange(val) {
                this.changeRecommendTeacher();
                this.search(val);
            },
            updateTeacher(idnex, row) {
                this.addTeacher = true;
                this.form = JSON.parse(JSON.stringify(row));
                if(this.form.teacherHeader != '') {
                    let file = {
                        name: "123.png",
                        url : this.form.teacherHeader
                    };
                    this.fileList.push(file);
                }
                this.hideUpload = this.fileList.length >= this.limitCount;
                this.title = "修改教师信息"
            },
            updateSort(row) {
                let params = row;
                https.fetchPost("/managerTeacher/updateSort",params ).then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if(code == '200') {
                        this.$message({
                            message: '排序成功',
                            type: 'success'
                        });
                        this.showEdit[row.teacherId] = false;
                        this.searchRecommendTeacher();
                    } else {
                        this.$message.error('添加失败:'+msg);
                    }

                }).catch(err=>{
                        this.$message.error('网络错误');
                    }
                )
            },
            teacherStatus(row, column, cellValue, index) {
                if(cellValue == 1) {
                    return "启用";
                }
                if(cellValue == 2) {
                    return "禁用";
                }
                if(cellValue == 2) {
                    return "锁定";
                }
                return "其他";
            },
            staffSex(row, column, cellValue, index) {
                if(cellValue == 1) { //（性别(0 未知；1女；2男)
                    return "女";
                }
                if(cellValue == 2) {
                    return "男";
                }

                return "未知";
            },
          selectOrg() {
            https.fetchGet('/managerOrganization/getOrganizationList','', 'from' ).then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if(code == 200) {
                this.org = data.data.data;
              } else {
                this.$message({
                  type: 'info',
                  message: msg
                });
              }

            }).catch(err=>{
                  this.$message.error('网络错误');
                }
            );
          },
            goBack() {
                this.$router.go(-1);
            },
        },
        created: function () {
            this.searchRecommendTeacher();
            this.selectOrg();
            this.uploadURL = this.https.baseURL+"/file/fdfs_upload";
        }
    };
</script>

<style>
    .but-cls {
        margin-bottom: 10px;
    }
    .cls-col {
        margin-right: 20px;
    }
    .hide .el-upload--picture-card {
        display: none;
    }
    .edit-cell {
        width: 60%;
    }
</style>